<div style="height:100%; overflow: visible;" *ngIf="outputHtml$ | async as outputHtml">
  <div style="position: relative;" [innerHTML]="outputHtml | safeHtml"></div>
</div>
